export default function VentilationHero() {
  return (
    <section className="relative min-h-[680px] flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20HVAC%20technician%20in%20dark%20uniform%20installing%20ventilation%20ductwork%20ceiling%20modern%20building%20Geneva%20Switzerland%20industrial%20dramatic%20lighting%20metal%20ducts%20air%20conditioning%20system%20technical%20precision&width=1920&height=700&seq=ventil-hero-v2-bg&orientation=landscape"
          alt="Installation ventilation VMC professionnelle à Genève"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-950/95 via-gray-950/75 to-gray-950/30"></div>
      </div>

      <div className="relative z-10 w-full mx-auto max-w-7xl px-6 lg:px-8 py-28">
        <div className="max-w-2xl">
          {/* Badge univers */}
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-amber-500/20 border border-amber-500/40">
              <i className="ri-tools-line text-amber-400 text-sm"></i>
            </div>
            <span className="text-xs font-bold tracking-widest uppercase text-amber-400">Univers Technique · HB Services</span>
          </div>

          <h1 className="text-5xl md:text-6xl font-bold tracking-tight text-white mb-6 leading-tight">
            Ventilation VMC<br />
            <span className="text-amber-400">double flux premium</span>
          </h1>
          <p className="text-lg text-white/70 leading-relaxed mb-10 max-w-xl">
            Air sain, économies d'énergie et silence absolu. Systèmes VMC double flux avec récupération de chaleur jusqu'à 95% pour résidences et commerces à Genève.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a href="#produits" className="inline-flex items-center justify-center gap-2 rounded-lg bg-amber-500 px-7 py-3.5 text-sm font-semibold text-white hover:bg-amber-600 transition-all whitespace-nowrap cursor-pointer">
              <i className="ri-windy-line"></i>
              Voir nos systèmes
            </a>
            <a href="#contact" className="inline-flex items-center justify-center gap-2 rounded-lg bg-white/8 backdrop-blur-sm px-7 py-3.5 text-sm font-semibold text-white border border-white/20 hover:bg-white/15 transition-all whitespace-nowrap cursor-pointer">
              <i className="ri-mail-send-line"></i>
              Devis gratuit
            </a>
          </div>

          {/* Stats */}
          <div className="mt-14 flex flex-wrap gap-10">
            {[
              { value: '95%', label: 'Récupération chaleur' },
              { value: '25 dB', label: 'Niveau sonore' },
              { value: '-30%', label: 'Coûts chauffage' },
            ].map((stat, i) => (
              <div key={i}>
                <div className="text-2xl font-bold text-white">{stat.value}</div>
                <div className="text-xs text-white/45 mt-0.5">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Badges flottants */}
      <div className="absolute bottom-8 right-8 hidden lg:flex flex-col gap-3">
        {[
          { icon: 'ri-leaf-line', text: 'Économies jusqu\'à 30%' },
          { icon: 'ri-heart-pulse-line', text: 'Air filtré & sain' },
          { icon: 'ri-volume-mute-line', text: 'Ultra-silencieux 25 dB' },
        ].map((b, i) => (
          <div key={i} className="flex items-center gap-2.5 bg-white/8 backdrop-blur-md border border-white/15 rounded-lg px-4 py-2.5">
            <i className={`${b.icon} text-amber-400 text-sm`}></i>
            <span className="text-xs font-medium text-white/80">{b.text}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
